import React from 'react';
import { MdOutlineMoreVert } from "react-icons/md";
import { CSS } from "@dnd-kit/utilities";
import { HiArchiveBox, HiDocument, HiEye, HiEyeSlash, HiFolderOpen } from "react-icons/hi2";
import { useSortable } from "@dnd-kit/sortable";
import { useNavigate } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FaArrowsUpDownLeftRight, FaGripVertical } from "react-icons/fa6";

import packageIcon from '../resources/file-package.svg';
import groupIcon from '../resources/group-package.svg';

interface Content {
    id: number;
    type: string;
    name: string;
    total: number;
    createdAt: string;
    updatedAt: string;
    ready: boolean;
}

interface Props {
    content: Content;
    onRemove: () => void;
    onDelete: () => void;
    hasRemoveFromGroup: boolean;
}

function ContentCard({ content, onRemove, onDelete, hasRemoveFromGroup }: Props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: content.id });
    const navigate = useNavigate();

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? "100" : "auto",
        opacity: isDragging ? 0.3 : 1
    };

    return (
        <div className="card" style={style} ref={setNodeRef}>

            <div className="menu">
                <Menu>
                    <MenuButton className="menu-button"><MdOutlineMoreVert size="26px"/></MenuButton>
                    <MenuItems
                        className="menu-box"
                        anchor="bottom"
                    >
                        <MenuItem>
                            <div className="menu-item" onClick={() => navigate(`/${content.type.toLowerCase()}/${content.id}`)}>
                                Edit
                            </div>
                        </MenuItem>
                        <MenuItem>
                            <div className="menu-item" onClick={onDelete}>
                                Delete
                            </div>
                        </MenuItem>
                        {

                            hasRemoveFromGroup && (
                                <MenuItem>
                                    <div className="menu-item" onClick={onRemove}>
                                        Remove from group
                                    </div>
                                </MenuItem>
                            )
                        }
                    </MenuItems>
                </Menu>
            </div>

            <FaArrowsUpDownLeftRight className="dragicon" size="24px" {...listeners} {...attributes} />
            {
                content.type === 'PACKAGE'
                    ? <img className="my-icon" src={packageIcon} onClick={() => navigate(`/${content.type.toLowerCase()}/${content.id}`)} />
                    : <img className="my-icon" src={groupIcon} onClick={() => navigate(`/${content.type.toLowerCase()}/${content.id}`)} />
            }
            <div className="card-title">{content.name}</div>
            <div>Created: {content.createdAt?.split(' ')[0]}</div>
            <div>Updated: {content.updatedAt?.split(' ')[0]}</div>
            <div className="hr"/>
            <div style={{ display: 'flex', gap: '4px' }}>
                {content.type === 'PACKAGE' ? <HiDocument size="16px"/> : <HiArchiveBox size="16px"/>}
                <div style={{ flex: 1 }}>{content.total}</div>
                <div style={{ alignSelf: 'end' }}>
                    {content.ready ? <HiEye/> : <HiEyeSlash/>}
                </div>
            </div>
        </div>
    );
}

export default ContentCard;
